import { render, staticRenderFns } from "./OldOders.vue?vue&type=template&id=992ae77a&"
import script from "./OldOders.vue?vue&type=script&lang=ts&"
export * from "./OldOders.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports